
export const text = `
When did you first learn you would never be the same again?

Did you wake up to it?
Did it hit you in the shower?
Did you look in the mirror and notice your eyes shone,
as if hit by unnatural light?

Dad would frame my old shoes each time I grew a size,
as if he could capture some spark of what made me;
If he was simply just fast enough,
He could keep me a child for just a moment longer.

Half a life later, I get why he did it.

Now I find myself clasping my hands when a butterfly lands between them,
Staring at blank pages before I begin to write,
Pressing the L key on my keyboard,
wondering what would happen if I held it there forever.

I have never worshiped stillness.
There is always so much to do: 
Time is a privilege for those with cameras and brushes,
And those who can sit with their legs crossed.

But what do I do with you?

You are changing before me and you don’t even know it:
For every head I cut you grow three, 
For every molar lost you gain fangs,
And when we held hands you sunk your claws into me;
You changed and did not even notice.

So is this our arrangement, now and forever?
Must I be the one to keep tight on your leash? 
Or worse, am I the hypocrite?
What was I doing by trying to stop you?
Did I change when I woke up this morning?

Maybe it’d be a mercy to keep you a memory,
Tucked in the depths of my father’s basement,
Or buried deep along with his coffin;
Somewhere I cannot kill you.

I don’t know.

It hurts to watch you turn into such a strange and wicked thing,
But I cannot peel my eyes away.





`